import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBookOutline = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "icon / ionicons / outline / book-outline",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector (Stroke)",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.875 3.12501C4.40792 3.1366 6.17347 3.45502 7.36099 4.02239C8.51273 4.57267 9.12953 5.35893 9.39414 6.40348C9.46439 6.68079 9.71394 6.875 10 6.875C10.2861 6.875 10.5356 6.68079 10.6059 6.40348C10.8705 5.35893 11.4873 4.57267 12.639 4.02239C13.8265 3.45502 15.5921 3.13659 18.125 3.125V14.375C13.6138 14.375 11.3982 15.1837 9.99995 16.5659C8.60659 15.19 6.38805 14.3764 1.8867 14.375C1.88137 14.3612 1.875 14.3369 1.875 14.2996V3.12501ZM1.39737 1.96907C1.5496 1.90636 1.71273 1.87439 1.87736 1.87501L1.87781 1.87501C4.48284 1.88669 6.46643 2.20965 7.89986 2.89451C8.83219 3.33996 9.52559 3.93634 10 4.67609C10.4744 3.93634 11.1678 3.33996 12.1001 2.89451C13.5336 2.20965 15.5172 1.88669 18.1222 1.87501L18.1226 1.87501C18.2873 1.87439 18.4504 1.90636 18.6026 1.96907C18.7549 2.03179 18.8932 2.12401 19.0096 2.24043C19.126 2.35685 19.2182 2.49515 19.2809 2.64737C19.3435 2.79913 19.3754 2.96173 19.375 3.12586V14.375C19.375 14.7065 19.2433 15.0245 19.0089 15.2589C18.7745 15.4933 18.4565 15.625 18.125 15.625C13.199 15.625 11.5056 16.6184 10.4881 17.8904C10.3694 18.0387 10.1898 18.125 9.99986 18.125C9.80994 18.125 9.63034 18.0386 9.51177 17.8902C8.50113 16.6256 6.80064 15.625 1.875 15.625C1.49801 15.625 1.1681 15.4654 0.9419 15.1997C0.723583 14.9433 0.625004 14.6178 0.625004 14.2996V3.12598C0.624567 2.96182 0.656532 2.79917 0.719074 2.64737C0.781791 2.49515 0.874015 2.35685 0.99043 2.24043C1.10685 2.12401 1.24515 2.03179 1.39737 1.96907Z",
			fill: "white"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector (Stroke)_2",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10 5.625C10.3452 5.625 10.625 5.90482 10.625 6.25V17.5C10.625 17.8452 10.3452 18.125 10 18.125C9.65482 18.125 9.375 17.8452 9.375 17.5V6.25C9.375 5.90482 9.65482 5.625 10 5.625Z",
			fill: "white"
		})]
	})
});
export default SvgBookOutline;
